// Tarifas DHL Express Worldwide Export desde Argentina — extraídas del tarifario
// oficial (código ARBZ00009/TDE_ECOMM_03, Ratecard as of 01-Jan-2026).
// Precios en USD, ya con adicionales. NO incluyen: combustible, cargos aduaneros,
// impuestos ni liberación de carga. Vigentes hasta el 31/12 del año cotizado.
// [peso_kg, zona1, zona2, zona3, zona4]
export const DHL_RATES: [number, number, number, number, number][] = [
  [0.5, 30.45, 37.02, 40.61, 43.51],
  [1.0, 30.45, 37.02, 40.61, 43.51],
  [1.5, 30.45, 37.02, 40.61, 43.51],
  [2.0, 34.11, 40.68, 44.27, 47.18],
  [2.5, 37.78, 44.34, 47.94, 52.26],
  [3.0, 41.44, 47.99, 53.05, 55.93],
  [3.5, 45.11, 53.11, 56.71, 59.59],
  [4.0, 48.76, 56.77, 60.37, 63.26],
  [4.5, 53.86, 60.44, 64.04, 66.92],
  [5.0, 57.52, 64.1, 67.69, 70.58],
  [5.5, 64.09, 70.65, 74.26, 77.14],
  [6.0, 70.64, 77.21, 80.82, 83.71],
  [6.5, 77.2, 83.77, 89.53, 92.39],
  [7.0, 83.76, 92.47, 96.06, 98.94],
  [7.5, 92.46, 99.04, 102.62, 105.51],
  [8.0, 99.03, 105.6, 109.19, 112.07],
  [8.5, 105.59, 112.14, 115.74, 118.64],
  [9.0, 112.13, 118.71, 124.44, 127.34],
  [9.5, 118.7, 127.4, 131.01, 133.88],
  [10.0, 127.39, 133.97, 137.56, 140.45],
  [10.5, 133.96, 140.52, 144.12, 147.01],
  [11.0, 140.51, 147.08, 150.68, 153.56],
  [11.5, 147.06, 153.64, 159.38, 162.27],
  [12.0, 153.63, 162.34, 165.95, 168.82],
  [12.5, 162.33, 168.89, 172.51, 175.37],
  [13.0, 168.88, 175.46, 179.04, 181.93],
  [13.5, 175.45, 182.02, 185.61, 188.49],
  [14.0, 182.01, 188.58, 194.31, 197.2],
  [14.5, 188.54, 197.28, 200.88, 203.76],
  [15.0, 197.27, 203.82, 207.43, 210.32],
  [15.5, 203.81, 210.39, 213.99, 216.87],
  [16.0, 210.38, 216.95, 220.55, 223.43],
  [16.5, 216.94, 223.5, 229.25, 232.13],
  [17.0, 223.49, 232.21, 235.8, 238.7],
  [17.5, 232.19, 238.76, 242.37, 245.24],
  [18.0, 238.75, 245.32, 248.92, 251.81],
  [18.5, 245.31, 251.88, 255.49, 258.36],
  [19.0, 251.87, 258.44, 264.18, 267.06],
  [19.5, 258.43, 267.15, 270.73, 273.63],
  [20.0, 267.14, 273.71, 277.3, 280.18],
  [21.0, 281.56, 291.31, 298.09, 304.21],
  [22.0, 295.98, 308.91, 318.88, 328.24],
  [23.0, 310.4, 326.51, 339.67, 352.27],
  [24.0, 324.82, 344.11, 360.46, 376.3],
  [25.0, 339.24, 361.71, 381.25, 400.33],
  [26.0, 353.66, 379.31, 402.04, 424.36],
  [27.0, 368.08, 396.91, 422.83, 448.39],
  [28.0, 382.5, 414.51, 443.62, 472.42],
  [29.0, 396.92, 432.11, 464.41, 496.45],
  [30.0, 411.34, 449.71, 485.2, 520.48],
  [31.0, 425.76, 467.31, 505.99, 544.51],
  [32.0, 440.18, 484.91, 526.78, 568.54],
  [33.0, 454.6, 502.51, 547.57, 592.57],
  [34.0, 469.02, 520.11, 568.36, 616.6],
  [35.0, 483.44, 537.71, 589.15, 640.63],
  [36.0, 497.86, 555.31, 609.94, 664.66],
  [37.0, 512.28, 572.91, 630.73, 688.69],
  [38.0, 526.7, 590.51, 651.52, 712.72],
  [39.0, 541.12, 608.11, 672.31, 736.75],
  [40.0, 555.54, 625.71, 693.1, 760.78],
  [41.0, 569.96, 643.31, 713.89, 784.81],
  [42.0, 584.38, 660.91, 734.68, 808.84],
  [43.0, 598.8, 678.51, 755.47, 832.87],
  [44.0, 613.22, 696.11, 776.26, 856.9],
  [45.0, 627.64, 713.71, 797.05, 880.93],
  [46.0, 642.06, 731.31, 817.84, 904.96],
  [47.0, 656.48, 748.91, 838.63, 928.99],
  [48.0, 670.9, 766.51, 859.42, 953.02],
  [49.0, 685.32, 784.11, 880.21, 977.05],
  [50.0, 699.74, 801.71, 901.0, 1001.08],
  [51.0, 714.16, 819.31, 921.79, 1025.11],
  [52.0, 728.58, 836.91, 942.58, 1049.14],
  [53.0, 743.0, 854.51, 963.37, 1073.17],
  [54.0, 757.42, 872.11, 984.16, 1097.2],
  [55.0, 771.84, 889.71, 1004.95, 1121.23],
  [56.0, 786.26, 907.31, 1025.74, 1145.26],
  [57.0, 800.68, 924.91, 1046.53, 1169.29],
  [58.0, 815.1, 942.51, 1067.32, 1193.32],
  [59.0, 829.52, 960.11, 1088.11, 1217.35],
  [60.0, 843.94, 977.71, 1108.9, 1241.38],
  [61.0, 858.36, 995.31, 1129.69, 1265.41],
  [62.0, 872.78, 1012.91, 1150.48, 1289.44],
  [63.0, 887.2, 1030.51, 1171.27, 1313.47],
  [64.0, 901.62, 1048.11, 1192.06, 1337.5],
  [65.0, 916.04, 1065.71, 1212.85, 1361.53],
  [66.0, 930.46, 1083.31, 1233.64, 1385.56],
  [67.0, 944.88, 1100.91, 1254.43, 1409.59],
  [68.0, 959.3, 1118.51, 1275.22, 1433.62],
  [69.0, 973.72, 1136.11, 1296.01, 1457.65],
  [70.0, 988.14, 1153.71, 1316.8, 1481.68],
  [71.0, 1002.56, 1171.31, 1337.59, 1505.71],
  [72.0, 1016.98, 1188.91, 1358.38, 1529.74],
  [73.0, 1031.4, 1206.51, 1379.17, 1553.77],
  [74.0, 1045.82, 1224.11, 1399.96, 1577.8],
  [75.0, 1060.24, 1241.71, 1420.75, 1601.83],
  [76.0, 1074.66, 1259.31, 1441.54, 1625.86],
  [77.0, 1089.08, 1276.91, 1462.33, 1649.89],
  [78.0, 1103.5, 1294.51, 1483.12, 1673.92],
  [79.0, 1117.92, 1312.11, 1503.91, 1697.95],
  [80.0, 1132.34, 1329.71, 1524.7, 1721.98],
  [81.0, 1146.76, 1347.31, 1545.49, 1746.01],
  [82.0, 1161.18, 1364.91, 1566.28, 1770.04],
  [83.0, 1175.6, 1382.51, 1587.07, 1794.07],
  [84.0, 1190.02, 1400.11, 1607.86, 1818.1],
  [85.0, 1204.44, 1417.71, 1628.65, 1842.13],
  [86.0, 1218.86, 1435.31, 1649.44, 1866.16],
  [87.0, 1233.28, 1452.91, 1670.23, 1890.19],
  [88.0, 1247.7, 1470.51, 1691.02, 1914.22],
  [89.0, 1262.12, 1488.11, 1711.81, 1938.25],
  [90.0, 1276.54, 1505.71, 1732.6, 1962.28],
  [91.0, 1290.96, 1523.31, 1753.39, 1986.31],
  [92.0, 1305.38, 1540.91, 1774.18, 2010.34],
  [93.0, 1319.8, 1558.51, 1794.97, 2034.37],
  [94.0, 1334.22, 1576.11, 1815.76, 2058.4],
  [95.0, 1348.64, 1593.71, 1836.55, 2082.43],
  [96.0, 1363.06, 1611.31, 1857.34, 2106.46],
  [97.0, 1377.48, 1628.91, 1878.13, 2130.49],
  [98.0, 1391.9, 1646.51, 1898.92, 2154.52],
  [99.0, 1406.32, 1664.11, 1919.71, 2178.55],
  [100.0, 1420.74, 1681.71, 1940.5, 2202.58],
  [101.0, 1435.16, 1699.31, 1961.29, 2226.61],
  [102.0, 1449.58, 1716.91, 1982.08, 2250.64],
  [103.0, 1464.0, 1734.51, 2002.87, 2274.67],
  [104.0, 1478.42, 1752.11, 2023.66, 2298.7],
  [105.0, 1492.84, 1769.71, 2044.45, 2322.73],
  [106.0, 1507.26, 1787.31, 2065.24, 2346.76],
  [107.0, 1521.68, 1804.91, 2086.03, 2370.79],
  [108.0, 1536.1, 1822.51, 2106.82, 2394.82],
  [109.0, 1550.52, 1840.11, 2127.61, 2418.85],
  [110.0, 1564.94, 1857.71, 2148.4, 2442.88],
  [111.0, 1579.36, 1875.31, 2169.19, 2466.91],
  [112.0, 1593.78, 1892.91, 2189.98, 2490.94],
  [113.0, 1608.2, 1910.51, 2210.77, 2514.97],
  [114.0, 1622.62, 1928.11, 2231.56, 2539.0],
  [115.0, 1637.04, 1945.71, 2252.35, 2563.03],
  [116.0, 1651.46, 1963.31, 2273.14, 2587.06],
  [117.0, 1665.88, 1980.91, 2293.93, 2611.09],
  [118.0, 1680.3, 1998.51, 2314.72, 2635.12],
  [119.0, 1694.72, 2016.11, 2335.51, 2659.15],
  [120.0, 1709.14, 2033.71, 2356.3, 2683.18],
  [121.0, 1723.56, 2051.31, 2377.09, 2707.21],
  [122.0, 1737.98, 2068.91, 2397.88, 2731.24],
  [123.0, 1752.4, 2086.51, 2418.67, 2755.27],
  [124.0, 1766.82, 2104.11, 2439.46, 2779.3],
  [125.0, 1781.24, 2121.71, 2460.25, 2803.33],
  [126.0, 1795.66, 2139.31, 2481.04, 2827.36],
  [127.0, 1810.08, 2156.91, 2501.83, 2851.39],
  [128.0, 1824.5, 2174.51, 2522.62, 2875.42],
  [129.0, 1838.92, 2192.11, 2543.41, 2899.45],
  [130.0, 1853.34, 2209.71, 2564.2, 2923.48],
  [131.0, 1867.76, 2227.31, 2584.99, 2947.51],
  [132.0, 1882.18, 2244.91, 2605.78, 2971.54],
  [133.0, 1896.6, 2262.51, 2626.57, 2995.57],
  [134.0, 1911.02, 2280.11, 2647.36, 3019.6],
  [135.0, 1925.44, 2297.71, 2668.15, 3043.63],
  [136.0, 1939.86, 2315.31, 2688.94, 3067.66],
  [137.0, 1954.28, 2332.91, 2709.73, 3091.69],
  [138.0, 1968.7, 2350.51, 2730.52, 3115.72],
  [139.0, 1983.12, 2368.11, 2751.31, 3139.75],
  [140.0, 1997.54, 2385.71, 2772.1, 3163.78],
  [141.0, 2011.96, 2403.31, 2792.89, 3187.81],
  [142.0, 2026.38, 2420.91, 2813.68, 3211.84],
  [143.0, 2040.8, 2438.51, 2834.47, 3235.87],
  [144.0, 2055.22, 2456.11, 2855.26, 3259.9],
  [145.0, 2069.64, 2473.71, 2876.05, 3283.93],
  [146.0, 2084.06, 2491.31, 2896.84, 3307.96],
  [147.0, 2098.48, 2508.91, 2917.63, 3331.99],
  [148.0, 2112.9, 2526.51, 2938.42, 3356.02],
  [149.0, 2127.32, 2544.11, 2959.21, 3380.05],
  [150.0, 2141.74, 2561.71, 2980.0, 3404.08],
  [151.0, 2156.16, 2579.31, 3000.79, 3428.11],
  [152.0, 2170.58, 2596.91, 3021.58, 3452.14],
  [153.0, 2185.0, 2614.51, 3042.37, 3476.17],
  [154.0, 2199.42, 2632.11, 3063.16, 3500.2],
  [155.0, 2213.84, 2649.71, 3083.95, 3524.23],
  [156.0, 2228.26, 2667.31, 3104.74, 3548.26],
  [157.0, 2242.68, 2684.91, 3125.53, 3572.29],
  [158.0, 2257.1, 2702.51, 3146.32, 3596.32],
  [159.0, 2271.52, 2720.11, 3167.11, 3620.35],
  [160.0, 2285.94, 2737.71, 3187.9, 3644.38],
  [161.0, 2300.36, 2755.31, 3208.69, 3668.41],
  [162.0, 2314.78, 2772.91, 3229.48, 3692.44],
  [163.0, 2329.2, 2790.51, 3250.27, 3716.47],
  [164.0, 2343.62, 2808.11, 3271.06, 3740.5],
  [165.0, 2358.04, 2825.71, 3291.85, 3764.53],
  [166.0, 2372.46, 2843.31, 3312.64, 3788.56],
  [167.0, 2386.88, 2860.91, 3333.43, 3812.59],
  [168.0, 2401.3, 2878.51, 3354.22, 3836.62],
  [169.0, 2415.72, 2896.11, 3375.01, 3860.65],
  [170.0, 2430.14, 2913.71, 3395.8, 3884.68],
  [171.0, 2444.56, 2931.31, 3416.59, 3908.71],
  [172.0, 2458.98, 2948.91, 3437.38, 3932.74],
  [173.0, 2473.4, 2966.51, 3458.17, 3956.77],
  [174.0, 2487.82, 2984.11, 3478.96, 3980.8],
  [175.0, 2502.24, 3001.71, 3499.75, 4004.83],
  [176.0, 2516.66, 3019.31, 3520.54, 4028.86],
  [177.0, 2531.08, 3036.91, 3541.33, 4052.89],
  [178.0, 2545.5, 3054.51, 3562.12, 4076.92],
  [179.0, 2559.92, 3072.11, 3582.91, 4100.95],
  [180.0, 2574.34, 3089.71, 3603.7, 4124.98],
  [181.0, 2588.76, 3107.31, 3624.49, 4149.01],
  [182.0, 2603.18, 3124.91, 3645.28, 4173.04],
  [183.0, 2617.6, 3142.51, 3666.07, 4197.07],
  [184.0, 2632.02, 3160.11, 3686.86, 4221.1],
  [185.0, 2646.44, 3177.71, 3707.65, 4245.13],
  [186.0, 2660.86, 3195.31, 3728.44, 4269.16],
  [187.0, 2675.28, 3212.91, 3749.23, 4293.19],
  [188.0, 2689.7, 3230.51, 3770.02, 4317.22],
  [189.0, 2704.12, 3248.11, 3790.81, 4341.25],
  [190.0, 2718.54, 3265.71, 3811.6, 4365.28],
  [191.0, 2732.96, 3283.31, 3832.39, 4389.31],
  [192.0, 2747.38, 3300.91, 3853.18, 4413.34],
  [193.0, 2761.8, 3318.51, 3873.97, 4437.37],
  [194.0, 2776.22, 3336.11, 3894.76, 4461.4],
  [195.0, 2790.64, 3353.71, 3915.55, 4485.43],
  [196.0, 2805.06, 3371.31, 3936.34, 4509.46],
  [197.0, 2819.48, 3388.91, 3957.13, 4533.49],
  [198.0, 2833.9, 3406.51, 3977.92, 4557.52],
  [199.0, 2848.32, 3424.11, 3998.71, 4581.55],
  [200.0, 2862.74, 3441.71, 4019.5, 4605.58],
  [201.0, 2877.16, 3459.31, 4040.29, 4629.61],
  [202.0, 2891.58, 3476.91, 4061.08, 4653.64],
  [203.0, 2906.0, 3494.51, 4081.87, 4677.67],
  [204.0, 2920.42, 3512.11, 4102.66, 4701.7],
  [205.0, 2934.84, 3529.71, 4123.45, 4725.73],
  [206.0, 2949.26, 3547.31, 4144.24, 4749.76],
  [207.0, 2963.68, 3564.91, 4165.03, 4773.79],
  [208.0, 2978.1, 3582.51, 4185.82, 4797.82],
  [209.0, 2992.52, 3600.11, 4206.61, 4821.85],
  [210.0, 3006.94, 3617.71, 4227.4, 4845.88],
  [211.0, 3021.36, 3635.31, 4248.19, 4869.91],
  [212.0, 3035.78, 3652.91, 4268.98, 4893.94],
  [213.0, 3050.2, 3670.51, 4289.77, 4917.97],
  [214.0, 3064.62, 3688.11, 4310.56, 4942.0],
  [215.0, 3079.04, 3705.71, 4331.35, 4966.03],
  [216.0, 3093.46, 3723.31, 4352.14, 4990.06],
  [217.0, 3107.88, 3740.91, 4372.93, 5014.09],
  [218.0, 3122.3, 3758.51, 4393.72, 5038.12],
  [219.0, 3136.72, 3776.11, 4414.51, 5062.15],
  [220.0, 3151.14, 3793.71, 4435.3, 5086.18],
  [221.0, 3165.56, 3811.31, 4456.09, 5110.21],
  [222.0, 3179.98, 3828.91, 4476.88, 5134.24],
  [223.0, 3194.4, 3846.51, 4497.67, 5158.27],
  [224.0, 3208.82, 3864.11, 4518.46, 5182.3],
  [225.0, 3223.24, 3881.71, 4539.25, 5206.33],
  [226.0, 3237.66, 3899.31, 4560.04, 5230.36],
  [227.0, 3252.08, 3916.91, 4580.83, 5254.39],
  [228.0, 3266.5, 3934.51, 4601.62, 5278.42],
  [229.0, 3280.92, 3952.11, 4622.41, 5302.45],
  [230.0, 3295.34, 3969.71, 4643.2, 5326.48],
  [231.0, 3309.76, 3987.31, 4663.99, 5350.51],
  [232.0, 3324.18, 4004.91, 4684.78, 5374.54],
  [233.0, 3338.6, 4022.51, 4705.57, 5398.57],
  [234.0, 3353.02, 4040.11, 4726.36, 5422.6],
  [235.0, 3367.44, 4057.71, 4747.15, 5446.63],
  [236.0, 3381.86, 4075.31, 4767.94, 5470.66],
  [237.0, 3396.28, 4092.91, 4788.73, 5494.69],
  [238.0, 3410.7, 4110.51, 4809.52, 5518.72],
  [239.0, 3425.12, 4128.11, 4830.31, 5542.75],
  [240.0, 3439.54, 4145.71, 4851.1, 5566.78],
  [241.0, 3453.96, 4163.31, 4871.89, 5590.81],
  [242.0, 3468.38, 4180.91, 4892.68, 5614.84],
  [243.0, 3482.8, 4198.51, 4913.47, 5638.87],
  [244.0, 3497.22, 4216.11, 4934.26, 5662.9],
  [245.0, 3511.64, 4233.71, 4955.05, 5686.93],
  [246.0, 3526.06, 4251.31, 4975.84, 5710.96],
  [247.0, 3540.48, 4268.91, 4996.63, 5734.99],
  [248.0, 3554.9, 4286.51, 5017.42, 5759.02],
  [249.0, 3569.32, 4304.11, 5038.21, 5783.05],
  [250.0, 3583.74, 4321.71, 5059.0, 5807.08],
  [251.0, 3598.16, 4339.31, 5079.79, 5831.11],
  [252.0, 3612.58, 4356.91, 5100.58, 5855.14],
  [253.0, 3627.0, 4374.51, 5121.37, 5879.17],
  [254.0, 3641.42, 4392.11, 5142.16, 5903.2],
  [255.0, 3655.84, 4409.71, 5162.95, 5927.23],
  [256.0, 3670.26, 4427.31, 5183.74, 5951.26],
  [257.0, 3684.68, 4444.91, 5204.53, 5975.29],
  [258.0, 3699.1, 4462.51, 5225.32, 5999.32],
  [259.0, 3713.52, 4480.11, 5246.11, 6023.35],
  [260.0, 3727.94, 4497.71, 5266.9, 6047.38],
  [261.0, 3742.36, 4515.31, 5287.69, 6071.41],
  [262.0, 3756.78, 4532.91, 5308.48, 6095.44],
  [263.0, 3771.2, 4550.51, 5329.27, 6119.47],
  [264.0, 3785.62, 4568.11, 5350.06, 6143.5],
  [265.0, 3800.04, 4585.71, 5370.85, 6167.53],
  [266.0, 3814.46, 4603.31, 5391.64, 6191.56],
  [267.0, 3828.88, 4620.91, 5412.43, 6215.59],
  [268.0, 3843.3, 4638.51, 5433.22, 6239.62],
  [269.0, 3857.72, 4656.11, 5454.01, 6263.65],
  [270.0, 3872.14, 4673.71, 5474.8, 6287.68],
  [271.0, 3886.56, 4691.31, 5495.59, 6311.71],
  [272.0, 3900.98, 4708.91, 5516.38, 6335.74],
  [273.0, 3915.4, 4726.51, 5537.17, 6359.77],
  [274.0, 3929.82, 4744.11, 5557.96, 6383.8],
  [275.0, 3944.24, 4761.71, 5578.75, 6407.83],
  [276.0, 3958.66, 4779.31, 5599.54, 6431.86],
  [277.0, 3973.08, 4796.91, 5620.33, 6455.89],
  [278.0, 3987.5, 4814.51, 5641.12, 6479.92],
  [279.0, 4001.92, 4832.11, 5661.91, 6503.95],
  [280.0, 4016.34, 4849.71, 5682.7, 6527.98],
  [281.0, 4030.76, 4867.31, 5703.49, 6552.01],
  [282.0, 4045.18, 4884.91, 5724.28, 6576.04],
  [283.0, 4059.6, 4902.51, 5745.07, 6600.07],
  [284.0, 4074.02, 4920.11, 5765.86, 6624.1],
  [285.0, 4088.44, 4937.71, 5786.65, 6648.13],
  [286.0, 4102.86, 4955.31, 5807.44, 6672.16],
  [287.0, 4117.28, 4972.91, 5828.23, 6696.19],
  [288.0, 4131.7, 4990.51, 5849.02, 6720.22],
  [289.0, 4146.12, 5008.11, 5869.81, 6744.25],
  [290.0, 4160.54, 5025.71, 5890.6, 6768.28],
  [291.0, 4174.96, 5043.31, 5911.39, 6792.31],
  [292.0, 4189.38, 5060.91, 5932.18, 6816.34],
  [293.0, 4203.8, 5078.51, 5952.97, 6840.37],
  [294.0, 4218.22, 5096.11, 5973.76, 6864.4],
  [295.0, 4232.64, 5113.71, 5994.55, 6888.43],
  [296.0, 4247.06, 5131.31, 6015.34, 6912.46],
  [297.0, 4261.48, 5148.91, 6036.13, 6936.49],
  [298.0, 4275.9, 5166.51, 6056.92, 6960.52],
  [299.0, 4290.32, 5184.11, 6077.71, 6984.55],
  [300.0, 4304.74, 5201.71, 6098.5, 7008.58],
];

// Arriba de 300 kg: se suma por cada kg adicional.
export const DHL_EXTRA_PER_KG = [14.42, 17.60, 20.79, 24.03];

// Servicios premium (se suman a la tarifa base).
export const DHL_PREMIUM = [
  { id: 'none', label: 'Estándar (sin premium)', extra: 0 },
  { id: '12', label: 'Premium 12:00', extra: 7 },
  { id: '1030', label: 'Premium 10:30', extra: 12 },
  { id: '9', label: 'Premium 9:00', extra: 30 },
];

// Destinos agrupados. La zona sale del tarifario oficial (página de zonificación):
// toda LATAM y Estados Unidos son Zona 1; Europa continental, Zona 2.
export const DHL_DESTINOS = [
  { id: 'latam', label: 'LATAM', zona: 1, detalle: 'Brasil, Chile, Uruguay, Paraguay, Bolivia, Perú, Colombia, Ecuador, México, Venezuela, Centroamérica y Caribe' },
  { id: 'usa', label: 'Estados Unidos', zona: 1, detalle: 'Estados Unidos, Puerto Rico, Islas Vírgenes (US), Canadá' },
  { id: 'europa', label: 'Europa', zona: 2, detalle: 'España, Italia, Francia, Alemania, Reino Unido, Portugal, Países Bajos, Bélgica, Suiza, Austria, Irlanda, Polonia y resto de Europa continental' },
  { id: 'zona3', label: 'Asia (zona 3)', zona: 3, detalle: 'China, Japón, India, Corea, Tailandia, Singapur, Taiwán, Vietnam, Filipinas, Indonesia' },
  { id: 'zona4', label: 'Resto del mundo (zona 4)', zona: 4, detalle: 'Oceanía, África, Medio Oriente, Islas Canarias y otros destinos de zona 4' },
];

// DHL cobra por el mayor entre peso real y peso volumétrico (L×An×Al / 5000).
export const DHL_VOLUMETRIC_DIVISOR = 5000;
